import { Content, Button, H1, H3, Row, Col } from 'components/common'
import { React, Image, styled, mq } from 'x'
import { compose, pure, lifecycle, withState } from 'recompose'

import Arrow from 'static/svg/arrow.svg'


const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: relative;
  flex-direction: column;
  justify-content: space-between;

  ${Row} {
    width:100%;
    text-align:left;
  }

  ${Col} {
    flex:1 1 100%;
  }
`

const MainTitle = styled(H1)`
  box-sizing: border-box;
  text-align:left;
  font-size: 42px;  
  margin-bottom:30px !important;
  color: #3e4d72;
  margin-bottom: 0;
  font-weight:800;
  line-height:1.2;
  width:100%;
  padding: 0 70px;
  ${mq.below('lg')} {
    padding: 0 60px;
  }
  ${mq.below('md')} {
    padding: 0 40px;
  }
  ${mq.below('sm')} {
    padding: 0 20px;
  }

  @media (min-width: 2000px) {
    max-width:1366px;
    margin-left: auto;
    margin-right: auto;
    padding-left:95px;
  }
`

const Slider = styled.div`
  width: 100%;
`

const Inner = styled.div`
  width: ${props => props.numSlides * 100}%;
  display: flex;
  min-height: 100%;
  position: relative;
  transform: translateX(-${props => props.index * (100 / props.numSlides)}%);
  transition: transform 0.7s cubic-bezier(0.645, 0.045, 0.355, 1);
`

const ContentWrapper = styled.div`
  display:flex;
  flex-direction: column;
  justify-content: flex-end;
  background-repeat: no-repeat;
  background-position: right 0 bottom -20px;
  background-size: auto;
  max-width: none;
  width: ${props => 100 / props.numSlides}%;
  opacity: ${props => (props.isActive ? 1 : 0)};
  transition: opacity 0.5s ease-out;
  padding-top: 120px;
  padding-bottom:120px;

  ${mq.below('xl')} {
    background-position: right -80px bottom 0;
    background-size: 70%;
  }

  ${mq.below('lg')} {
    padding-top:80px;
    padding-bottom: 80px;
    background-position: right -60px bottom -20px;
  }

  ${mq.below('md')} {
    background-position: right bottom;
    background-size: 40%;
  }

  @media (min-width: 2000px) {
    background-size: contain;
    background-position-x: calc(50% + 400px);
  }
`

const StyledContent = styled(Content)`
  max-width:100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  position: relative;
  box-sizing: border-box;
  height:100%;

  @media (min-width: 2000px) {
    max-width:1366px;
    justify-content:flex-start;
  }

  ${mq.below('lg')} {
    padding: 0 80px;
  }
  ${mq.below('md')} {
    padding: 0 60px;
  }
  ${mq.below('sm')} {
    padding: 0 40px;
  }
`

const Title = styled(H1)`
  ${mq.above('xl')} {
    width:65%;
  }

  font-size: 42px;  
  color: #000;
  margin-bottom: 0;
  font-weight:800;
  line-height:1.2;
  width:100%;

  ${mq.below('xl')} {
    width:50%;
  }

  ${mq.below('lg')} {
    width:45%;
  }

  ${mq.below('sm')} {
    width:100%;
  }
`

const Subtitle = styled(H3)`
  ${mq.above('xl')} {
    width:65%;
  }

  font-size: 28px;
  line-height: 1.2;
  color: #000;
  margin: 0 0 30px 0;
  font-weight: 800;
  width:100%;

  ${mq.below('xl')} {
    width:50%;
  }

  ${mq.below('lg')} {
    width:45%;
  }

  ${mq.below('sm')} {
    width:100%;
  }
`

const Text = styled.div`
  ${mq.above('xl')} {
    width:65%;
  }

  font-size: 26px;
  line-height: 30px;
  color: #000;
  margin: 30px 0;
  font-weight: 600;
  width:100%;

  ul {
    margin:0;
    padding:0;
    li {
      list-style-type: none;
      padding:0 0 40px 0;
      display:flex;
      flex-direction:row;
      flex-wrap:nowrap;
      &:before {
        content: "›";
        display:block;
        font-size:30px;
        width:20px;
        height:20px;
        line-height:30px;
      }
    }
  }

  ${mq.below('xl')} {
    width:50%;
  }

  ${mq.below('lg')} {
    width:45%;
  }

  ${mq.below('sm')} {
    width:100%;
  }
`

const AnimatedButton = styled(Button)`
  height: 46px;
  line-height: 46px;
  min-width: 200px;
  font-size:20px;
  font-weight: 800;
  text-transform: capitalize;
  color: #3e4d72;
  & svg {
    transition: transform 0.3s;
    &.circle {
      background-color: #3e4d72;;
      fill: #ffffff;
      opacity:0.7;
    }
  }
  &:hover {
    color: #3e4d72;
    & svg {
      transform: translateX(10px);
      &.circle {
        opacity:1;
      }
    }
  }
  ${mq.below('sm')} {
    min-width:auto;
  }
`

const Lower = styled.div`
  padding-top:20px;
  width: 100%;
  z-index: 2;
`

const Dot = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 15px;
  margin-right: 7px;
  cursor: pointer;
  border: 2px solid
    ${props => (props.isActive ? '#3e4d72' : '#3e4d72')};
  background: ${props =>
    props.isActive ? '#3e4d72' : 'transparent'};
  &:hover {
    color: #3e4d72;
    transform: scale(1.1);
  }
`

const Dots = styled.div`
  ${mq.above('lg')} {
    align-self: center;
  }

  display: flex;
  margin-top: 20px;
  align-self: flex-start;
  padding-bottom: 10px;
`

const enhance = compose(
  pure,
  withState('index', 'setIndex', 0),
  withState('timeout', 'setTimeout', 0),
  lifecycle({
    componentDidMount() {
      if (this.props.data.slider && this.props.data.sldBodyAutoloop) {
        const startTimer = () =>
          this.props.setTimeout(
            setTimeout(() => {
              const numSlides = this.props.data.slider.length

              if (this.props.index + 1 > numSlides - 1) {
                this.props.setIndex(0)
              } else {
                this.props.setIndex(this.props.index + 1)
              }

              startTimer()
            }, parseInt(this.props.data.sldBodyDuration, 10))
          )

        startTimer()
      }
    },

    componentWillUnmount() {
      clearTimeout(this.props.timeout)
    }
  })
)

const HeroSlider = props => {
  const slides = props.data.slider
    ? props.data.slider
    : [
        {
          bgColour: props.data.bgColour,
          image: props.data.image,
          title: props.data.title,
          subtitle: props.data.subtitle,
          ctaLabel: props.data.ctaLabel,
          ctaUrl: props.data.ctaUrl
        }
      ]

  const numSlides = slides.length

  const nextType = props?.list?.[1]?.__typename

  return (
    <Container>
      <Row>
        <Col>
          <MainTitle>{props.data.sldTitle}</MainTitle>
        </Col>
      </Row>
      <Slider>
        <Inner index={props.index} numSlides={numSlides}>
          {slides.map((slide, index) => (
            <ContentWrapper numSlides={numSlides} key={'slide-' + index} isActive={props.index === index} style={{backgroundColor: slide.bgColour || 'white', backgroundImage: `url(${slide.image.imgixImageWp.imageUrl})`}} >
              <StyledContent numSlides={numSlides}>
                <div>
                  <Title>{slide.title}</Title>
                  {slide.subtitle && <Subtitle>{slide.subtitle}</Subtitle>}
                  {slide.text && ( 
                    <Text>
                    <div dangerouslySetInnerHTML={{ __html: slide.text }}></div>
                    </Text>
                  )}
                  {slide.ctaLabel && (
                    <AnimatedButton to={slide.ctaUrl}>
                      <span>{slide.ctaLabel}</span>
                      <Arrow className="circle" />
                    </AnimatedButton>
                  )}
                </div>
              </StyledContent>
              <Lower>
                {numSlides > 1 && (
                  <StyledContent>
                    <Dots>
                      {slides.map((slide, index) => (
                        <Dot
                          key={'dot-' + index}
                          isActive={props.index === index}
                          onClick={() => props.setIndex(index)
                          }
                        />
                      ))}
                    </Dots>
                  </StyledContent>
                )}
              </Lower>
            </ContentWrapper>
          ))}
        </Inner>
      </Slider>
    </Container>
  )
}

export default enhance(HeroSlider)
